import { Navigate } from "react-router-dom";
import Login from "../auth/Login";
import Tips from "../pages/tips/Tips";
import EditTip from "../pages/tips/EditTip";
import ProtectedRoute from "../components/ProtectedRoute";
import Blogs from "../pages/blogs/Blogs";
import BlogsEdit from "../pages/blogs/BlogsEdit";
import BlogsAdd from "../pages/blogs/BlogsAdd";
import ProductsList from "../pages/products/ProductsList";
import ProductsEdit from "../pages/products/ProductsEdit";
import ProductsAdd from "../pages/products/ProductsAdd";
import PrivacyPolicy from "../pages/other/PrivacyPolicy";
import Faq from "../pages/faqs/Faq";
import FaqEdit from "../pages/faqs/FaqEdit";
import Subscription from "../pages/subscription/Subscription";
import Cms from "../pages/cms/Cms";
import Options from "../pages/options/Options";
import CmsEdit from "../pages/cms/CmsEdit";
import UserList from "../pages/user/UserList";
import SettingsList from "../pages/settings/SettingsList";
import SettingsAdd from "../pages/settings/SettingsAdd";
import ContactList from "../pages/contact/ContactList";
import Calendar from "../pages/calendar/Calendar";
import Replay from "../pages/contact/Replay";
import Dashboard from "../pages/dashboard/Dashboard";
import PartnerList from "../pages/partner/PartnerList";
import BroadcastNotifications from "../pages/broadcast/BroadcastNotifications";
import WebsiteEnquiry from "../pages/website/WebsiteEnquiry";
import CouponCode from "../pages/coupon/CouponCode";
import TestimonialList from "../pages/testimonial/TestimonialList";
import TestimonialAdd from "../pages/testimonial/TestimonialAdd";
import Category from "../pages/category/Category";
import CatyegoryEdit from "../pages/category/CategoryEdit";
import CatyegoryAdd from "../pages/category/CategoryAdd";
import SMSLead from "../pages/smsLead/SMSLead";
import AIChat from "../pages/AIChat/AIChat";
import NewsLetter from "../pages/newsLetter/NewsLetter";

const routes = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/tips",
    element: (
      <ProtectedRoute>
        <Tips />
      </ProtectedRoute>
    ),
  },
  {
    path: "/sms-lead",
    element: (
      <ProtectedRoute>
        <SMSLead />
      </ProtectedRoute>
    ),
  },
  {
    path: "/news-letter",
    element: (
      <ProtectedRoute>
        <NewsLetter />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ai-chat",
    element: (
      <ProtectedRoute>
        <AIChat />
      </ProtectedRoute>
    ),
  },

  {
    path: "/tips/add",
    element: (
      <ProtectedRoute>
        <EditTip />
      </ProtectedRoute>
    ),
  },

  {
    path: "/tips/edit/:id",
    element: (
      <ProtectedRoute>
        <EditTip />
      </ProtectedRoute>
    ),
  },

  {
    path: "/blogs",
    element: (
      <ProtectedRoute>
        <Blogs />
      </ProtectedRoute>
    ),
  },

  {
    path: "/blogs/edit/:id",
    element: (
      <ProtectedRoute>
        <BlogsEdit />
      </ProtectedRoute>
    ),
  },

  {
    path: "/blogs/add",
    element: (
      <ProtectedRoute>
        <BlogsAdd />
      </ProtectedRoute>
    ),
  },

  {
    path: "/products",
    element: (
      <ProtectedRoute>
        <ProductsList />
      </ProtectedRoute>
    ),
  },

  {
    path: "/products/edit/:id",
    element: (
      <ProtectedRoute>
        <ProductsEdit />
      </ProtectedRoute>
    ),
  },

  {
    path: "/products/add",
    element: (
      <ProtectedRoute>
        <ProductsAdd />
      </ProtectedRoute>
    ),
  },

  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },

  {
    path: "/faq",
    element: (
      <ProtectedRoute>
        <Faq />
      </ProtectedRoute>
    ),
  },
  {
    path: "/faq/add",
    element: (
      <ProtectedRoute>
        <FaqEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/faq/edit/:id",
    element: (
      <ProtectedRoute>
        <FaqEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cms",
    element: (
      <ProtectedRoute>
        <Cms />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cms/add",
    element: (
      <ProtectedRoute>
        <CmsEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cms/edit/:id",
    element: (
      <ProtectedRoute>
        <CmsEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/options",
    element: (
      <ProtectedRoute>
        <Options />
      </ProtectedRoute>
    ),
  },
  {
    path: "/subscription",
    element: (
      <ProtectedRoute>
        <Subscription />
      </ProtectedRoute>
    ),
  },

  {
    path: "/user",
    element: (
      <ProtectedRoute>
        <UserList />
      </ProtectedRoute>
    ),
  },

  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/add",
    element: (
      <ProtectedRoute>
        <SettingsAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings/edit/:id",
    element: (
      <ProtectedRoute>
        <SettingsAdd />
      </ProtectedRoute>
    ),
  },

  {
    path: "/testimonial",
    element: (
      <ProtectedRoute>
        <TestimonialList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/testimonial/add",
    element: (
      <ProtectedRoute>
        <TestimonialAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/testimonial/edit/:id",
    element: (
      <ProtectedRoute>
        <TestimonialAdd />
      </ProtectedRoute>
    ),
  },

  {
    path: "/contact",
    element: (
      <ProtectedRoute>
        <ContactList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/partner",
    element: (
      <ProtectedRoute>
        <PartnerList />
      </ProtectedRoute>
    ),
  },

  {
    path: "/calendar",
    element: (
      <ProtectedRoute>
        <Calendar />
      </ProtectedRoute>
    ),
  },

  {
    path: "/contact/replay/:id",
    element: (
      <ProtectedRoute>
        <Replay />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },

  {
    path: "/broadcast-notification",
    element: (
      <ProtectedRoute>
        <BroadcastNotifications />
      </ProtectedRoute>
    ),
  },

  {
    path: "/website-enquiry",
    element: (
      <ProtectedRoute>
        <WebsiteEnquiry />
      </ProtectedRoute>
    ),
  },

  {
    path: "/coupon-code",
    element: (
      <ProtectedRoute>
        <CouponCode />
      </ProtectedRoute>
    ),
  },

    {
    path: "/category",
    element: (
      <ProtectedRoute>
        <Category />
      </ProtectedRoute>
    ),
  },

   {
    path: "/category/edit/:id",
    element: (
      <ProtectedRoute>
        <CatyegoryEdit />
      </ProtectedRoute>
    ),
  },

  {
    path: "/category/add",
    element: (
      <ProtectedRoute>
        <CatyegoryAdd />
      </ProtectedRoute>
    ),
  },

  {
    path: "*",
    element: <Navigate to="/login" />,
  },
];
export default routes;
